import React from 'react'

//@ts-ignore
import { components } from 'react-select'

const Control = ({ children, ...props }: any) => {
  const selectedOptions = props.getValue()

  return <components.Control {...props}>{children}</components.Control>
}

export default Control
